import { c as _c } from "react/compiler-runtime";
import type { TempMedia } from '@/payload-types';
import { isError } from '@/utilities/serverError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trash2 } from 'lucide-react';
import Image from 'next/image';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { deleteTempImage } from '../actionsImage';
import { getExtension, isImage } from './tempMediaUtils';
export function TempMediaList(t0) {
  const $ = _c(9);
  const {
    tempMedia
  } = t0;
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== queryClient) {
    t1 = {
      mutationFn: async t2 => {
        const {
          id
        } = t2;
        const result = await deleteTempImage(id);
        if (isError(result)) {
          toast.error(result.message);
          return;
        }
        queryClient.invalidateQueries({
          queryKey: ["tempMedia"]
        });
      }
    };
    $[0] = queryClient;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const deleteMutation = useMutation(t1);
  if (tempMedia.length === 0) {
    return null;
  }
  let t2;
  if ($[2] !== deleteMutation || $[3] !== tempMedia) {
    let t3;
    if ($[5] !== deleteMutation) {
      t3 = media => <div key={media.id} className="border-primary/20 relative rounded-md border p-1">{isImage(media) ? <Image src={media.url || ""} alt={media.filename || "reference image"} width={160} height={90} className="h-15 w-20 rounded-md object-cover" /> : <div className="bg-muted text-muted-foreground flex h-15 w-20 flex-col items-center justify-center rounded-md text-xs font-medium" title={media.filename || undefined}><div className="text-muted-foreground text-xs">{media.filename.slice(0, 10)}</div><div className="text-muted-foreground text-xs">{getExtension(media)}</div></div>}<Button variant="ghost" size="icon" className="bg-background/90 absolute top-1 right-1 h-6 w-6 rounded-full" onClick={async () => deleteMutation.mutateAsync({
          id: media.id
        })} disabled={deleteMutation.isPending}><Trash2 className="h-3 w-3" /></Button></div>;
      $[5] = deleteMutation;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = tempMedia.map(t3);
    $[2] = deleteMutation;
    $[3] = tempMedia;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="flex flex-wrap gap-3">{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}